const getDeploymentStage = () => {
  const hostname = window.location.hostname;

  if (
    ['bill.dev-utrust.com', 'bill.dev.crypto.xmoney.com'].includes(hostname)
  ) {
    return 'development';
  }

  if (
    ['bill.staging-utrust.com', 'bill.staging.crypto.xmoney.com'].includes(
      hostname
    )
  ) {
    return 'staging';
  }

  if (
    ['bill.sandbox-utrust.com', 'bill.sandbox.crypto.xmoney.com'].includes(
      hostname
    )
  ) {
    return 'sandbox';
  }

  if (['bill.utrust.com', 'bill.crypto.xmoney.com'].includes(hostname)) {
    return 'production';
  }

  return 'local';
};

export default getDeploymentStage;
